import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import TranscriptSummary from './TranscriptSummary';

const TranscriptSummaryPicker = ({ meetingTranscriptResource, content, handleSubmit }) => {
  return pickFunction(meetingTranscriptResource, {
    [fr.relationships.callSummaries.name]: () => {
      return (
        <TranscriptSummary
          key={meetingTranscriptResource.id()}
          content={content}
          handleSubmit={handleSubmit}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default TranscriptSummaryPicker;
